<template>
  <div id="loginPage">
    
    <!-- 1. 动态背景层 (氛围感核心) -->
    <div class="background-blobs">
      <div class="blob blob-1"></div>
      <div class="blob blob-2"></div>
      <div class="blob blob-3"></div>
    </div>

    <!-- 2. 内容主体容器 -->
    <div class="main-container">
      
      <!-- 顶部标题 (Apple风格大标题) -->
      <!-- <div class="header">
        <transition name="fade" mode="out-in">
          <div class="sub-title" v-if="!currentRole" key="select">请选择登录身份</div>
          <div class="sub-title" v-else key="role">{{ roleNameMap[currentRole] }}登录</div>
        </transition>
      </div> -->

      <!-- 阶段一：身份选择 (iOS Widget 风格) -->
      <transition name="slide-up" mode="out-in">
        <div class="role-selection" v-if="!currentRole" key="selection">
          
          <div class="glass-card role-card" @click="selectRole('parent')">
            <div class="card-content">
              <!-- <div class="text-group">
                <h3>我是家长</h3>
                <p>Parent Login</p>
              </div> -->
              <div class="icon-wrap">
                <!-- 替换为您实际的图片，这里使用了占位图演示效果 -->
                <img src="@/assets/user-parent.png" alt="家长" class="role-img"/>
              </div>
            </div>
          </div>

          <div class="glass-card role-card" @click="selectRole('teacher')">
            <div class="card-content">
              <!-- <div class="text-group">
                <h3>我是老师</h3>
                <p>Teacher Login</p>
              </div> -->
              <div class="icon-wrap">
                <img src="@/assets/user-teacher.png" alt="老师" class="role-img"/>
              </div>
            </div>
          </div>

        </div>

        <!-- 阶段二：登录表单 (iOS 设置列表风格) -->
        <div class="form-container glass-panel" v-else key="form">
          <form class="login-form">
            
            <!-- 输入区域 -->
            <div class="input-group">
              <!-- 学校 -->
              <div class="input-item">
                <span class="label">学校</span>
                <input 
                  type="text" 
                  placeholder="请搜索选择学校（如：南京）" 
                  v-model="schoolName" 
                  readonly 
                  @click="schoolshowPicker = true"
                >
                <i class="arrow-icon"></i>
              </div>

              <!-- 账号 -->
              <div class="input-item">
                <span class="label">{{ accountLabel }}</span>
                <input 
                  type="text" 
                  :placeholder="'请输入' + accountLabel" 
                  v-model="account"
                >
              </div>

              <!-- 姓名 -->
              <div class="input-item">
                <span class="label">姓名</span>
                <input 
                  type="text" 
                  placeholder="请输入姓名" 
                  v-model="userName"
                >
              </div>

              <!-- 密码 -->
              <div class="input-item no-border">
                <span class="label">密码</span>
                <input 
                  type="password" 
                  placeholder="请输入密码" 
                  v-model="passWord"
                >
              </div>
            </div>

            <!-- 登录按钮 -->
            <button type="button" class="login-btn" @click="getLogin">
              登 录
            </button>
            
            <!-- 切换身份 -->
            <div class="back-link" @click="currentRole = ''">
              <span>切换身份</span>
            </div>
          </form>
        </div>
      </transition>
    </div>

    <!-- Vant 组件保持不变 -->
    <van-popup v-model="schoolshowPicker" round position="bottom" :style="{ height: '50%' }">
      <van-search v-model="searchvalue" placeholder="请输入学校名称关键字搜索（如：南京）" shape="round" />
      <van-picker
        :columns="columns"
        show-toolbar
        confirm-button-text="确定"
        cancel-button-text="取消"
        @cancel="schoolshowPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>

    <div id="container" style="display: none"></div>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import { Dialog } from 'vant'
import { getSchoolList } from '@/api/common'

export default {
  name: 'loginPage',
  data() {
    return {
      currentRole: '', 
      roleNameMap: {
        parent: '家长',
        student: '学生',
        teacher: '老师'
      },
      userName: '',
      account: '', 
      passWord: '',
      schoolName: '',
      schoolId: '',
      searchvalue: '',
      schoolshowPicker: false,
      columnsAll: [],
      columns: [],
      lat: '',
      lon: ''
    }
  },
  computed: {
    accountLabel() {
      if (this.currentRole === 'student') return '学号'
      if (this.currentRole === 'teacher') return '工号'
      if (this.currentRole === 'parent') return '手机号'
      return '账号'
    }
  },
  created() {
    this.columns = [];
  },
  watch: {
    searchvalue(val) {
      if (!val || !val.trim()) {
        this.columns = [];
        return;
      }
      this.getSchoolList(val.trim());
    }
  },
  methods: {
    selectRole(role) {
      this.currentRole = role
      this.account = ''
      this.passWord = ''
      this.userName = ''
    },
    getSchoolList(keyword) {
      if (!keyword || !keyword.trim()) {
        this.columns = [];
        return;
      }
      getSchoolList({ keyword: keyword.trim() }).then((res) => {
        const body = res?.data?.body || res?.data?.data || res?.data || [];
        if (Array.isArray(body)) {
          this.columns = body.map((item) => ({
            text: item.name || item.schName || '',
            value: item.code || item.schCode || ''
          })).filter(i => i.text && i.value);
        } else {
          this.columns = [];
        }
      }).catch((err) => {
        console.warn("获取学校失败", err);
        this.columns = [];
      });
    },
    onConfirm(val) {
      this.schoolName = val.text
      this.schoolId = val.value
      this.schoolshowPicker = false
    },
    getLogin() {

      Dialog.alert({
  title: '提示',
  message: '暂未开放！',
  closeOnClickOverlay: true, // 点击遮罩层可关闭
  confirmButtonText: '确定'
})
.then(() => {
  console.log('用户点击了确定');
  Dialog.close();
});
      // 模拟登录逻辑
      // localStorage.setItem('Authorization', 'mock-token')
      // sessionStorage.setItem('userInfo', JSON.stringify({
      //   id: "stu-test", 
      //   studentName: "杨森", 
      //   role: this.currentRole
      // }))
      
      // if (this.currentRole === 'parent') {
      //   this.$router.push('/parentCenter')
      // } else {
      //   this.$router.push('/myFitness')
      // }
    }
  }
}
</script>

<style lang="less" scoped>
/* ========== 全局重置与基础设置 ========== */
#loginPage {
  width: 100%;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "PingFang SC", "Helvetica Neue", Arial, sans-serif;
  background-color: #f2f4f6; /* 兜底色 */
  color: #333;
}

/* ========== 1. 动态背景光斑 (极致柔和) ========== */
.background-blobs {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  
  .blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    opacity: 0.6;
  }
  .blob-1 {
    width: 300px;
    height: 300px;
    background: #a0c4ff;
    top: -50px;
    left: -50px;
    animation: float 8s infinite ease-in-out;
  }
  .blob-2 {
    width: 250px;
    height: 250px;
    background: #b9fbc0;
    bottom: -50px;
    right: -50px;
    animation: float 8s infinite ease-in-out reverse;
  }
}
// @keyframes float {
//   0%, 100% { transform: translate(0, 0) rotate(0deg); }
//   33% { transform: translate(30px, -50px) rotate(10deg); }
//   66% { transform: translate(-20px, 20px) rotate(-5deg); }
// }

/* ========== 2. 布局容器 ========== */
.main-container {
  position: relative;
  z-index: 1;
  min-height: calc(100vh - 80px);
  padding: 40px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 600px;
  margin: 0 auto;
}

/* ========== 3. 头部标题 ========== */
.header {
  text-align: center;
  margin-bottom: 40px;
  
  .title {
    font-size: 28px;
    font-weight: 700;
    color: #1d1d1f;
    letter-spacing: 1px;
    margin-bottom: 8px;
  }
  .sub-title {
    font-size: 15px;
    color: #86868b;
    font-weight: 400;
  }
}

/* ========== 4. 通用磨玻璃卡片样式 ========== */
.glass-card, .glass-panel {
  background: rgba(255, 255, 255, 0.15); /* 提高透明度 */
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.8); 
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15); 
  border-radius: 24px;
  overflow: hidden;
}

/* ========== 5. 身份选择卡片 ========== */
.role-selection {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .role-card {
    cursor: pointer;
    transition: transform 0.2s cubic-bezier(0.25, 0.1, 0.25, 1), box-shadow 0.2s;
    
    &:active {
      transform: scale(0.98);
      background: rgba(255, 255, 255, 0.8);
    }

    .card-content {
      padding: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .text-group {
      h3 {
        font-size: 20px;
        font-weight: 600;
        margin: 0 0 6px 0;
        color: #1d1d1f;
      }
      p {
        font-size: 13px;
        color: #86868b;
        margin: 0;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
    }

    .icon-wrap {
      // width: 64px;
      // height: 64px;
      border-radius: 16px;
      overflow: hidden;
      
      .role-img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

/* ========== 6. 表单样式 (iOS Grouped List 风格) ========== */
.form-container {
  padding: 30px 20px;
}

.input-group {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 16px;
  padding: 0 16px;
  margin-bottom: 24px;
  
  /* 输入框项 */
  .input-item {
    display: flex;
    align-items: center;
    height: 56px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    position: relative;

    &.no-border {
      border-bottom: none;
    }

    .label {
      width: 70px;
      font-size: 15px;
      font-weight: 500;
      color: #1d1d1f;
    }

    input {
      flex: 1;
      border: none;
      background: transparent;
      height: 100%;
      font-size: 16px;
      color: #1d1d1f;
      padding-left: 10px;
      outline: none;
      
      &::placeholder {
        color: #a1a1a6;
      }
    }

    .arrow-icon {
      /* 可选：添加一个小箭头表示下拉 */
      width: 8px;
      height: 8px;
      border-top: 2px solid #c7c7cc;
      border-right: 2px solid #c7c7cc;
      transform: rotate(45deg);
      margin-left: 5px;
    }
  }
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 50px;
  background: #007aff; /* Apple Blue */
  border: none;
  border-radius: 25px;
  color: white;
  font-size: 17px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 122, 255, 0.3);
  transition: all 0.2s;
  cursor: pointer;

  &:active {
    background: #0062cc;
    transform: scale(0.99);
  }
}

/* 切换身份链接 */
.back-link {
  text-align: center;
  margin-top: 20px;
  
  span {
    color: #86868b;
    font-size: 14px;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: #007aff;
    }
  }
}

/* ========== Vue Transition 动画 ========== */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active, .slide-up-leave-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.slide-up-enter {
  opacity: 0;
  transform: translateY(20px);
}
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>